<template>
  <div id="questions" @click="closePopups">
    <div id="questionsDiv">
      <div class="leftArrow" :class="{noNextPrev: (curQuestionIndex === 0)}" @click="prevMobileMentorQuestion">
        <img src="@/assets/img/Main_leftArrow.png">
      </div>

      <div id="questionsContent">
        <div v-for="question in mobileMentorQuestions" :key="'question-'+ question.id">
          <div v-if="question.id === currentModuleQuestion">
            <div class="questionsContainer">
              <div class="contentModuleName" v-html="question.module"></div>
              <div class="questionText" v-html="question.question_text"></div>
              <div class="questionBody" v-html="question.question_body"></div>
              <transition name="popup">
                <div class="glossPopup" v-if="showGlossPopup" :style="{top: glossPopupTop + 'px', left: glossPopupLeft + 'px'}">
                  <div class="glossaryTerm" v-html="glossTerm"></div>
                  <div class="glossaryDef" v-html="glossDef"></div>
                </div>
              </transition>
              <transition name="popup">
                <div class="imagePopup" v-if="showImagePopup">
                  <img :src="'./assets/modules/' + moduleAssetFolderName + '/images/' + imageName" v-click-outside="closeImagePopup"/>
                </div>
              </transition>
            </div>
            
            <div class="relatedTopicsContainerSmall" :class="{relatedTopicsOpen: showRelatedTopics}">
              <div class="rtHeading" @click="toggleRelatedTopics()">Related Topics</div>
              <div class="rtLinks">
                <div v-for="(link, linkIndex) in question.relatedQuestions" v-html="prettyPrintRelatedQuestion(link)" @click="seekRelatedQuestion(link)" :key="'relatedTopicSmall-' + linkIndex"></div>
              </div>
            </div>

            <transition name="fadeBlocker">
              <div id="RTSmallBlocker" v-if="showRelatedTopics" @click="showRelatedTopics = false"></div>
            </transition>
   
            <div class="relatedTopicsContainer">
              <!-- <img width="100%" src="@/assets/img/main.jpg"/> -->
              <img width="100%" class="related-topic-image" :src="('./assets/modules/' + moduleAssetFolderName + '/images/' + question.id + '.png')" />
              <div class="rtHeadingBig" v-show="question.relatedQuestions.length > 0">RELATED TOPICS</div>
              <div class="rtLinksContainer" v-show="question.relatedQuestions.length > 0">
                <div class="rtLinksBig" v-for="(link, linkIndex) in question.relatedQuestions" v-html="prettyPrintRelatedQuestion(link)" @click="seekRelatedQuestion(link)" :key="'relatedTopic-' + linkIndex"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="disclaimer"><img src="@/assets/img/CLD_logo_poweredBy.png" width="100px" /></div>

      <div class="rightArrow" :class="{noNextPrev: (curQuestionIndex === (mobileMentorQuestions.length - 1))}" @click="nextMobileMentorQuestion">
        <img src="@/assets/img/Main_rightArrow.png">
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import vClickOutside from 'v-click-outside'

export default {
  name: 'MobileMentor',
  props: {
    
  },
  watch: {
    questionHistory(newHistory, oldHistory){
      if(newHistory.length < oldHistory.length){
        let theMobileMentor = this;
        theMobileMentor.destroyListeners()
        theMobileMentor.$nextTick(() => {
          theMobileMentor.createListeners()
          theMobileMentor.scrollToTop()
        })
      }
    },
    currentModuleQuestion(){
      let theMobileMentor = this;
      if(!theMobileMentor.refreshing){
        theMobileMentor.destroyListeners()
        theMobileMentor.$nextTick(() => {
          theMobileMentor.createListeners()
          theMobileMentor.scrollToTop()
        })
      }
    },
    viewedQuestions(){
      let theMobileMentor = this;
      if(!theMobileMentor.completed && !theMobileMentor.requiresAttestation){
        if(theMobileMentor.viewedQuestions.length === theMobileMentor.mobileMentorQuestions.length){
          theMobileMentor.completeModule(true);
        }
      }
    },
    showTOC(shouldShow){
      let theMobileMentor = this;
      if(theMobileMentor.viewedQuestions.length === 0){
        // add first question to list of viewed questions after first hide of TOC, else user will have to revisit it to have it marked as viewed/completed
        if(!shouldShow){
          if(!theMobileMentor.viewedQuestions.includes(theMobileMentor.mobileMentorQuestions[0].id)){
            let updatedViewedQuestions = theMobileMentor.viewedQuestions;
            updatedViewedQuestions.push(theMobileMentor.mobileMentorQuestions[0].id);
            theMobileMentor.updateViewedModuleQuestions(updatedViewedQuestions);
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'mobileMentorQuestions',
      'mediaItems',
      'glossaryTerms',
      'showTOC',
      'currentModule',
      'currentModuleQuestion',
      'completed',
      'requiresAttestation',
      'viewedQuestions',
      'questionHistory',
      'moduleAssetFolderName',
      'disclaimer',
    ]),
    curQuestionIndex(){
      let theMobileMentor = this;
      return theMobileMentor.mobileMentorQuestions.findIndex(question => question.id === theMobileMentor.currentModuleQuestion);
    }
  },
  methods: {
    ...mapActions([
      'hideResults',
      'displayResults',
      'openModal',
      'completeModule',
      'changeModule',
      'changeModuleQuestion',
      'updateViewedModuleQuestions',
    ]),
    toggleRelatedTopics(){
      let theMobileMentor = this;
      theMobileMentor.showRelatedTopics = !theMobileMentor.showRelatedTopics
    },
    triggerPopup(eventDetails){
      let theMobileMentor = this;
      theMobileMentor.$nextTick(() => {
        let popupType = (eventDetails.target.className === 'glossaryLink' ? 'glossary' : 'image');
        if(popupType === 'glossary'){
          theMobileMentor.glossTerm = eventDetails.target.innerHTML;
          theMobileMentor.glossDef = theMobileMentor.findGlossDefinition(theMobileMentor.glossTerm);
          theMobileMentor.setGlossPopupLocation(eventDetails)
          theMobileMentor.showGlossPopup = true;
        }else{
          theMobileMentor.imageName = eventDetails.target.id + '.png';
          theMobileMentor.showImagePopup = true;
        }
      })
    },
    closeGlossPopup(){
      this.showGlossPopup = false;
    },
    closeImagePopup(){
      this.showImagePopup = false;
    },
    closePopups(eventDetails){
      // only kill popups if user clicked outside of one
      let clickedPopup = ['glossaryLink','imagePop'].includes(eventDetails.target.className);
      if(!clickedPopup){
        this.showGlossPopup = false;
        this.showImagePopup = false;
      }
    },
    findGlossDefinition(glossTerm){
      let theMobileMentor = this;
      let glossDef = '';
      for(var i = 0; i < theMobileMentor.glossaryTerms.length; i++){
        // if the clicked glossary term matches the term, altTerm, or plural term
        if(theMobileMentor.glossaryTerms[i].term === glossTerm || theMobileMentor.glossaryTerms[i].altTerm === glossTerm || theMobileMentor.glossaryTerms[i].term === glossTerm.slice(0, -1)){
          glossDef = theMobileMentor.glossaryTerms[i].definition;
          break;
        }
      }
      return glossDef;
    },
    setGlossPopupLocation(eventDetails){
      let theMobileMentor = this;
      let xDown = eventDetails.target.getBoundingClientRect().left - 20;
      let yDown = eventDetails.target.getBoundingClientRect().top - 20;
      let wInnWidth = window.innerWidth;
      if(wInnWidth == null){
        wInnWidth = document.body.offsetWidth;
      }
      let wQInnWidth = document.getElementById('questionsContent').offsetWidth;
      let wQInnHeight = document.getElementById('questionsContent').offsetHeight;
      let scrollTop = document.getElementById('questionsContent').scrollTop;
      let offsetXW = Math.abs(wInnWidth - wQInnWidth);
      xDown = xDown - offsetXW/2;

      if(xDown > 629){
        xDown = 629;
      }
      if(xDown < 0){
        xDown = 0;
      }
      if(yDown > wQInnHeight){
        yDown = yDown + wQInnHeight + 200
      }

      yDown += scrollTop;

      if(window.innerHeight > window.innerWidth && xDown < wQInnWidth){ 
        theMobileMentor.glossPopupLeft = 50;
      }else{
        theMobileMentor.glossPopupLeft = xDown;
      }
      theMobileMentor.glossPopupTop = yDown;
    },
    scrollToTop(){
      document.getElementById('questionsContent').scroll({top:0,behavior:'smooth'});
    },
    progressAndRefresh(newQuestion){
      let theMobileMentor = this;
      theMobileMentor.refreshing = true;
      theMobileMentor.destroyListeners()
      theMobileMentor.changeModuleQuestion(newQuestion)
      theMobileMentor.$nextTick(() => {
        theMobileMentor.createListeners()
        theMobileMentor.scrollToTop()
        theMobileMentor.refreshing = false;
      })
    },
    prevMobileMentorQuestion(){
      let theMobileMentor = this;
      if((theMobileMentor.curQuestionIndex !== -1) && (theMobileMentor.curQuestionIndex - 1 >= 0)){
        let newQuestion = theMobileMentor.mobileMentorQuestions[(theMobileMentor.curQuestionIndex-1)];
        theMobileMentor.progressAndRefresh(newQuestion)
      }
    },
    nextMobileMentorQuestion(){
      let theMobileMentor = this;
      if((theMobileMentor.curQuestionIndex !== -1) && (theMobileMentor.curQuestionIndex + 1 <= (theMobileMentor.mobileMentorQuestions.length - 1))){
        let newQuestion = theMobileMentor.mobileMentorQuestions[(theMobileMentor.curQuestionIndex+1)];
        theMobileMentor.progressAndRefresh(newQuestion)
      }
    },
    // try to find related question based on the given question_text or ID
    seekRelatedQuestion(questionTextOrID){
      let theMobileMentor = this;
      let isQuestionID = (typeof questionTextOrID === 'object');
      let matchingQuestion = theMobileMentor.mobileMentorQuestions.find(question => {
        if(isQuestionID){
          return question.id === questionTextOrID.id
        }
        return question.question_text === questionTextOrID;
      });
      if(matchingQuestion){
        theMobileMentor.progressAndRefresh(matchingQuestion)
      }else{
        console.log('Related question not found.')
      }
    },
    // basically just convert the ID object to an actual question name if necessary
    prettyPrintRelatedQuestion(questionTextOrID){
      let theMobileMentor = this;
      let isQuestionID = (typeof questionTextOrID === 'object');
      if(isQuestionID){
        let questionText = 'Related Topic'
        let matchingQuestion = theMobileMentor.mobileMentorQuestions.find(question => question.id === questionTextOrID.id);
        if(matchingQuestion){
          questionText = matchingQuestion.question_text;
        }else{
          console.log('Related question not found.')
        }
        return questionText;
      }
      return questionTextOrID;
    },
    createListeners(){
      let theMobileMentor = this;
      let glossaryLinks = document.querySelectorAll('.glossaryLink');
      let popupImages = document.querySelectorAll('.imagePop');
      let eventsToAdd = ['click', 'touchend'];

      eventsToAdd.forEach(eventToAdd => {
        glossaryLinks.forEach(link => link.addEventListener(eventToAdd, theMobileMentor.triggerPopup));
        popupImages.forEach(image => image.addEventListener(eventToAdd, theMobileMentor.triggerPopup));
      })
    },
    destroyListeners(){
      let theMobileMentor = this;
      let glossaryLinks = document.querySelectorAll('.glossaryLink');
      let popupImages = document.querySelectorAll('.imagePop');
      let eventsToRemove = ['click', 'touchend'];

      eventsToRemove.forEach(eventToRemove => {
        glossaryLinks.forEach(link => link.removeEventListener(eventToRemove, theMobileMentor.triggerPopup));
        popupImages.forEach(image => image.removeEventListener(eventToRemove, theMobileMentor.triggerPopup));
      })
    }
  },
  mounted(){
    let theMobileMentor = this;
    theMobileMentor.createListeners();
  },
  data(){
    return {
      showGlossPopup: false,
      showImagePopup: false,
      showRelatedTopics: false,
      glossPopupLeft: 0,
      glossPopupTop: 0,
      glossTerm: '',
      glossDef: '',
      imageName: '',
      refreshing: false,
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.moduleQuestion{
  cursor: pointer;
  max-width: 80%;
  float: left;
  box-sizing: border-box;
}

.questionViewed{
  float: left;
  margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

#questionsDiv{
  top: 50px;
  position: fixed;
  left: 0;
  right: 0;
  height: calc(100% - 50px);
  overflow-y: hidden;
  z-index: 2;
}

#questionsContent{
  position: relative;
  display: block;
  width: 80%;
  height: calc(100vh - 100px);
  margin: 0 auto;
  background-color: white;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  float: left;
}

.bullet2{
  margin-left:20px;
}

.leftArrow{
  float: left;
  width: 10%;
  height: 100%;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
}

.rightArrow{
  float: left;
  width: 10%;
  height: 100%;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
}

.noNextPrev{
  cursor: default;
  opacity: 0.2;
}

.questionsContainer{
  float: left;
  width: 70%;
  padding: 2%;
  padding-top: 25px;
  box-sizing: border-box;
}

.contentModuleName{
  font-family: MontserratMedium;
  font-size: 22px;
  color: black;
  font-style: italic;
}

.questionText{
  font-family: MontserratBlack;
  font-size: 40px;
  color: #0084b9;
  line-height: 1.1em;
  margin-bottom: 20px;
  margin-top: 10px;
}

.questionBody > p > img{
  width: 100%;
}

.imageFloatRight{
  /*float: right;*/
  margin-left: 10px;
  margin-top: 10px;
}

.glossPopup{
  position: absolute;
  width: 300px;
  background-color: #EBF9FF;
  border: 2px solid #0084b9;
  border-left: 6px solid #0084b9;
  padding: 10px;
  z-index: 3;
}

.glossaryLink, .imagePop{
  color: #0084b9;
  text-decoration: underline;
  cursor: pointer;
}

.imagePopup{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.imagePopup > img{
  align-self: center;
}

.imagePopClose{
  margin-right: 50px;
  width: 25px;
  height: 25px;
  border: 4px solid #ffffff;
  color: #ffffff;
  line-height: 25px;
  margin-left: auto;
  cursor: pointer;
}

@media(max-width: 600px ){
  .glossPopup{
    width: 250px;
  }
}
/*.glossPopup:after{
  position: absolute;
    width: 20px;
    height: 20px;
    border-top: 2px solid #0084b9;
    border-right: 0px solid #0084b9;
    border-bottom: 0px solid #0084b9;
    border-left: 2px solid #0084b9;
    top: 0;
    left: 50%;
    margin-left: -10px;
    content: "";
    transform: rotate(45deg);
    margin-top: -12px;
    background-color: white;
}*/

.popup{

  -webkit-transition: opacity 1s; 
  -moz-transition: opacity 1s; 
  -o-transition: opacity 1s; 
  transition: opacity 1s;
  
}

.popup-enter-active{
  animation: scale-in .5s;
} 
.popup-leave-active{
  transition: opacity 0s;
}
.popup-enter, .popup-leave-to /* .fade-leave-active below version 2.1.8 */{

}

@keyframes scale-in{
  0%{
    transform: scale(0);
  }
  100%{
    transform: scale(1);
  }
}

.glossaryTerm{
  color: #0084b9;
  font-weight: bold;
  padding-bottom: 5px;
}
.relatedTopicsContainer{
  position: fixed;
  top: 80px;
  right: 12%;
  width: 20%;
}
.related-topic-image{
  /*max-height: 50%;*/
  /*max-width: 100%;*/
  /*max-width: 200px;*/
}

.relatedTopicsContainerSmall{
  width: 300px;
  height: 50%;
  position: absolute;
  right: -300px;
  display: none;
  background-color: white;
  transition: right .5s;
  margin-top: 40%;
  align-items: center;
  position: fixed;
  z-index: 4;
  border: 3px solid #f8981d;
  box-sizing: border-box;

}
.rtHeading{
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  transform: rotate(-90deg);
  position: absolute;
  box-sizing: border-box;
  height: 30px;
  left: 0;
  transform-origin: -101% -323%;
  margin-top: 100%;
  padding: 5px;
  background-color: #f8981d;
  color: white;
  cursor: pointer;
}

.rtLinksContainer{
  border: 3px solid #f8981d;
  padding: 20px;
  height: 250px;
  overflow-y: auto;
}

.rtHeadingBig{
  font-family: MontserratBlack;
  font-size: 22px;
  background-color: #f8981d;
  color: white;
  padding: 10px 20px;
}
.rtLinks{
  float: left;
}
.rtLinksBig{
  color: black;
  cursor: pointer;
  text-decoration: underline;
  margin-top: 5px;

}
.relatedTopicsOpen{
  right: 0;
  transition: right .5s;
}

#RTSmallBlocker{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  overflow: auto;
  background-color: rgba(0,0,0,.5);
  z-index: 3;
}

table{
  border: 1px solid #0b9bef;
  margin-bottom: 15px;
}

.tableHeading{
  font-weight: bold;
  text-align: center;
  color: #0b9bef;
  font-size: 16px;
  padding: 5px;
}

.tableHeading td{
  border-top: 1px solid #0b9bef;
  border-bottom: 1px solid #0b9bef;
  border-left: none;
  border-right: none;
}

.tableColHeading td{
  border-left: 1px solid #0b9bef;
  border-right: 1px solid #0b9bef;
  border-top: 1px solid #0b9bef;
  border-bottom: none;
  font-weight: bold;
  background-color: #d2e8fb;
  padding: 5px 10px;
}

.tableColHeading td:first-child, .tableBody td:first-child{
  border-left: 0px;
}

.tableColHeading td:last-child, .tableBody td:last-child{
  border-right: 0px;
}

.tableBody td{
  border-top: none;
  border-bottom: 1px solid #0b9bef;
  border-left: 1px solid #0b9bef;
  border-right: 1px solid #0b9bef;
  background-color: #a5d1f7;
}

.footnote, .footnote2{
  margin: -15px auto 15px auto;
  font-size: 13px;
  line-height: 1.2rem;
}

.footnote2{
  padding-left: 12px;
  text-indent: -12px;
}

.closerLookTable{
  border-collapse: collapse;
  padding: 0px;
  margin: 0px;
  margin-bottom: 15px;
}

.closerLookHeading td{
  text-align: left;
  font-size: 20px;
  font-weight: bold;
  border: none;
}

.closerLookHeadingText{
  background-color: #0b9bef;
  color: #85cdf7;
  padding: 5px 0px 0px 15px;
  display: flex;
  align-items: center;
}

.closerLookBody td{
  border: none;
  vertical-align: bottom;
}

.closerLookText{
  padding: 15px;
  margin: 0px;
  text-align: left;
  vertical-align: bottom;
  background-color: #ffffff;
}

.closerLookImg{
  padding: 0px 0px 0px 15px;
  margin: 0px;
  text-align: right;
  vertical-align: bottom;
  background-color: #a5d1f7;
}

.closerLookImg img{
  vertical-align: text-bottom;
}

.closerLookCallout{
  padding: 0px;
  margin: 0px;
  border: none;
  text-align: left;
}



@media(max-width: 900px){
  #iconContainer{
    width: calc(100% - 120px);
    margin-left: 20px;
  }
  #questionContainer{
    width: 100%;
  }
  #pretestResults{
    width: 100%;
  }
  #questionsContent{
    width: 100%;
    height: calc(100% - 56px);
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .resultContainer{
    padding-left: 0;
  }
  #resultsContainerLeft{
    /*position: fixed;*/
  }
  #resultsContainerRight{
    width: 60%;
    padding-left: 35px;
  }
  .relatedTopicsContainer{
    right: 20px;
    width: 25%;
  }
  .leftArrow{
    position: fixed;
    display: block;
    bottom: 0;
    left: 0;
    z-index: 1;
    width: 50%;
    height: 56px;
    text-align: left;
    background-color: #97cb59;
  }
  .rightArrow{
    position: fixed;
    display: block;
    bottom: 0;
    right: 0;
    z-index: 1;
    width: 50%;
    height: 56px;
    text-align: right;
    background-color: #97cb59;
  }
  #searchResults{
    width: 100%;
    height: 100%;
    z-index: 3;
  }
  .imagePopup > img{
    width: 90%;
  }
}


@media screen and (max-width: 767px) and (orientation:landscape){
  .imagePopup > img{
    width: 80%;
    height: 90%;
  }
}


@media(max-width: 667px){
  #questionContainer{
    width: 100%;
    height: 100%;
  }

  .moduleName{
    width: 85%;
    padding-left: 10px;
  }

  #resultsContinue{
    margin-top: 15px;
  }
  .questionsContainer{
    width: 100%;
    height: 100%;
    margin: 0;
    padding-left: 20px;
    padding-right: 35px;
    overflow-y: auto;
    padding-bottom: 50px;
    -webkit-overflow-scrolling: touch;
  }

  .relatedTopicsContainerSmall{
    display: flex;

  }
  .relatedTopicsContainer{
    display: none;
  }

  .rtLinks{
    position: absolute;
    left: 35px;
    width: calc(100% - 35px);
    z-index: 2;
    cursor: pointer;
  }

  .fadeBlocker-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    transition-delay: .5s;
  }
  #searchInputContainer > input{
    width: 100px;
  }
  .imageFloatRight{
    float: none;
    margin-left: 0px;
    margin-top: 0px;
  }
  .imagePopup > img{
    width: 100%;
  }
  .glossPopup{
    position: fixed;
  }
}

@media(max-height: 670px){
  .relatedTopicsContainer{
    position: absolute;
    top: 25px;
    right: 3%;
    width: 25%;
  }
}

.disclaimer {
  bottom: 0px;
  position: absolute;
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
}

</style>
